import { useEffect } from 'react';
import { useLocalObservable } from 'mobx-react';

import wrapInContainer from '../wrapInContainer';
import App from './App';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import { getErrorPageModel } from '../../utils/error';
import { validatePartnerPageName } from '../../utils/validate';
import { makePartnersLandingPageUrl } from '../../utils/urlProvider';
import { isPartnerSiteUnavailable } from '../../utils/partnerSiteAvailability';

const { useRootStore } = generatedHooks;

const mapProps = () => {
  try {
    const rootStore = useRootStore(store => store);

    const state = useLocalObservable(() => ({
      showErrorPage: false,
      showLoadingPage: true,
      errorCode: null,
      partnerSiteIsUnavailable: false,
      partnerSiteCheckFailed() {
        this.partnerSiteIsUnavailable = true;
      },
      initializationFailed(errorCode) {
        this.showErrorPage = true;
        this.errorCode = !errorCode ? null : errorCode;
        this.showLoadingPage = false;
      },
      initializationSucceed() {
        this.showLoadingPage = false;
      },
    }));

    useEffect(() => {
      (async () => {
        try {
          const { pathname, search } = window.location;
          const pathParts = pathname.split('/');
          const pageName = pathParts[pathParts.length - 1];

          if (!validatePartnerPageName(pageName)) {
            state.initializationFailed();
            return;
          }

          const query = search.substring(1);

          await rootStore.init(pageName, query);

          // Проверку ждём под прелоадером: иначе пользователь сначала увидит
          // сломанный iframe и только потом сообщение поверх него.
          try {
            if (await isPartnerSiteUnavailable(rootStore.partnerPage.iframeUrl)) {
              state.partnerSiteCheckFailed();
            }
          } catch (error) {
            // Проверка доступности — вспомогательная: если она сама упала,
            // показываем страницу партнёра как обычно.
            logger.error(error, { sentryMessage: 'partner site availability check failed' });
          }

          state.initializationSucceed();
        } catch (error) {
          const errorCode = !!error.response && !!error.response.status
            ? error.response.status
            : null;
          state.initializationFailed(errorCode);
          logger.error(error, { sentryMessage: 'initialization failed' });
        }
      })();
    }, []);

    const handleButtonClick = () => {
      window.open(makePartnersLandingPageUrl(), '_self');
    };

    const onError = () => {
      window.open(makePartnersLandingPageUrl(), '_self');
    };

    if (state.showLoadingPage) {
      return {
        showLoadingPage: state.showLoadingPage,
      };
    }

    if (state.showErrorPage) {
      onError();
    }

    const { partnerPage } = rootStore;
    const {
      systemName,
      iframeUrl,
      iframeHeight,
      seoMetaTags,
      advertiserFirmInn,
      advertiserFirmName,
      erir,
      showAdvertisementBlock,
    } = partnerPage;

    return {
      systemName,
      title: seoMetaTags.title,
      description: seoMetaTags.description,
      iframeUrl,
      iframeHeight,
      advertiserFirmInn,
      advertiserFirmName,
      erir,
      handleButtonClick,
      showAdvertisementBlock,
      partnerSiteIsUnavailable: state.partnerSiteIsUnavailable,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'appHOC error' });
    return {
      showErrorPage: true,
      errorPageModel: getErrorPageModel(),
    };
  }
};

export default wrapInContainer(App, mapProps);
